// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const ReviewsSignatureService = {
    /**
     * Get retrieves the signature for a given location and user.
     * Returns the signature and signature_id. If no signature exists, it will return an empty signature.
     */
    Get(fn, req) {
        return fn(`/reviews/signature/v1/signature?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * UpsertSignature creates or updates a signature for a given location and user.
     * Returns the signature and signature_id.
     */
    Upsert(fn, req) {
        return fn(`/reviews/signature/v1/signature`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
